module.exports = __webpack_public_path__ + "img/50min.6d39b216.jpg";